export default __webpack_public_path__ + "static/media/btn_step_2_hover.44a0f50c.svg";